var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.928401 7H1.93287C2.00117 7 2.06545 6.96825 2.10563 6.91619L5.91054 1.94349L9.71546 6.91619C9.75563 6.96825 9.81992 7 9.88822 7H10.8927C10.9797 7 11.0306 6.90603 10.9797 6.83873L6.25742 0.666031C6.08599 0.44254 5.7351 0.44254 5.56501 0.666031L0.842686 6.83873C0.790454 6.90603 0.841348 7 0.928401 7Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.a2935d4df00f795e62077f894456f3da.svg";
export { ForwardRef as ReactComponent };